module.exports = __webpack_public_path__ + "static/media/carroussel_21.0129825d.jpg";